// src/context/SiteSettingsContext.jsx
// Context สำหรับค่าตั้งค่าเว็บไซต์ (รูป Hero หน้า Landing + ไอคอนระบบ)
// - ดึงค่า GET /api/site-settings ตอน mount ครั้งเดียว (สาธารณะ ไม่ต้อง login)
// - หน้า /settings/site ใช้ refresh() หลังบันทึกเพื่อให้หน้าอื่น ๆ อัปเดตตาม
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config/api';

const SiteSettingsContext = createContext({ settings: {}, refresh: () => {} });

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/site-settings`);
      setSettings(res.data || {});
    } catch {
      setSettings({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteSettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
